import React, { useState } from 'react';

import logo from '../../Assets/Capacitaciones/Header.jpg';

import moment from "moment";
import {View, Text, Document, Page, Image, StyleSheet} from '@react-pdf/renderer';
//import logo from '../../media/logoART.png';//import logo from '../../media/Logo_completo.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';
import firma_peger from '../../Assets/Capacitaciones/firma_peger.jpg'; //import firma from '../../media/Firma.png'; 
import firma_voytenco from '../../Assets/Capacitaciones/firma_voytenco.jpg';


    const styles = StyleSheet.create({  

    footer: {
        //position: 'absolute',
        bottom: 10,
        left: 0,
        right: 0,
        //textAlign: 'center',
        //marginHorizontal: 'center',
        //alignItems: 'center',
        //justifyContent: 'center',
        //color: 'gray'
    },

    imagen: {
        opacity: 0.2,
        position: "absolute",
        left: '120px',
        right: '120px',
        top: '100rem',
        marginHorizontal: 'center',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },

    grupoFirma1:{
        margin: '0 0 0 100',
        flexDirection: 'column',
        /*alignItems: 'left',
        alignContent: 'left',
        justifyContent: 'left',
        textAlign: 'left',*/
    },

    grupoFirma2:{
        margin: '0 0 0 180',
        flexDirection: 'column',
        /*alignItems: 'right',
        alignContent: 'right',
        justifyContent: 'right',
        textAlign: 'right',*/
    },
    firma1: {
        width: '30%',
        /*marginHorizontal: 'center',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',*/
        //margin: '0 0 0 20',
    },

    firma2: {
        width: '45%',
        margin: '50 0 0 30',
    },

    firmaAcalracion:{
        //margin: '0 0 0 340',
        //flexDirection: 'column',
        fontSize: 12,
    },

    cabeceraTitulo: {
        top: '120rem',
        textAlign: 'center',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',  
        fontSize: 20, 
        fontWeight: 'bold',
    },
    
    cabeceraNombre: {
        
        fontSize: 32,
        fontWeight: 'bold',
        alignContent: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        borderBottomWidth: 2,
    },

    texto: {
        fontSize: 18,
        alignContent: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontWeight: 'bold',
        color: 'grey'
    },

    cuerpo:{
        padding: '0% 8%',
    },



    
    });

    const Capacitacion_Certificado_PDF_Cabecera = (props) => {

        console.log('NOMBRE: ',props.nombre)

        return (
                <>
                    <View style={styles.cuerpo}>
                        <View >
                            <Image source={logo} style={styles.imagen} /> 
                            
                        </View>
                        
                        <View style={styles.cabeceraTitulo}>  
                                <Text>CERTIFICADO DE APROBACIÓN</Text>   
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                                <Text>  </Text>
                        </View> 
                        <View>
                            <Text style={styles.cabeceraNombre}>{props.nombre.trim()}</Text>
                        </View>
                     
                        <Text style={styles.texto}> Ha aprobado satisfactoriamente el curso introductorio de Sistema de Riesgos del Trabajo</Text>
                        <Text>  </Text>
                        <Text>  </Text>
                        <View>
                            <View style={{flexDirection: 'row'}}>
                                <View style={styles.grupoFirma1}>
                                    <Image source={firma_voytenco} style={styles.firma1} />  
                                    <View style={styles.firmaAcalracion}>
                                            <Text>José Voytenco</Text>
                                            <Text>Presidente Art Mutual Rural</Text>
                                    </View>   
                                </View>

                                <View style={styles.grupoFirma2}>
                                    <Image source={firma_peger} style={styles.firma2} />  
                                    <View style={styles.firmaAcalracion}>
                                            <Text>Pedro Pablo Peger</Text>
                                            <Text>Secretario Art Mutual Rural</Text>
                                    </View> 
                                </View>
                            </View>
                        </View>
                    </View>
                </>
        )
    }


export default Capacitacion_Certificado_PDF_Cabecera;